import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { createSelector } from 'reselect'

import { selectCockpitFirstPartnerOfferingsCatalog } from './selectCockpitFirstPartnerOfferingsCatalog'
import { selectCockpitMode } from './selectCockpitMode'
import { selectCockpitOffering } from './selectCockpitOffering'

/** The programme in view is switched off for the partner. Only a partner switches a programme
 *  off; the manager cockpit shows the ones its partners plan. */
export const selectIsCockpitOfferingSwitchedOff = createSelector(
  [selectCockpitMode, selectCockpitOffering, selectCockpitFirstPartnerOfferingsCatalog],
  (cockpitMode, selectedOffering, offeringsCatalog) =>
    cockpitMode === 'partner' &&
    selectedOffering !== ProgramTypes.Overall &&
    offeringsCatalog.some(
      ({ programType, enabled }) => programType === selectedOffering && !enabled
    )
)
